import React from 'react';
import { CheckCircle2, Info, AlertTriangle, RotateCcw } from 'lucide-react';

const VARIANTS = {
  success: {
    color: '#10F2A0',
    Icon: CheckCircle2,
    titleRecruiter: 'PRE-QUALIFIED CANDIDATE',
    titleCandidate: 'You are pre-qualified',
    subtitleRecruiter: 'Hiring process initiated successfully',
    subtitleCandidate: 'Thank you. The recruiter will contact you shortly.',
  },
  rejected: {
    color: '#FF3B5C',
    Icon: Info,
    titleRecruiter: 'Does Not Meet Current Requirements',
    titleCandidate: 'Thank you for your time',
    subtitleRecruiter: 'Thank you for the candidate\'s time.',
    subtitleCandidate: 'Your responses have been recorded.',
  },
  review: {
    color: '#FF9F1C',
    Icon: AlertTriangle,
    titleRecruiter: 'Manual Review Required',
    titleCandidate: 'Manual Review Required',
    subtitleRecruiter: 'A recruiter will follow up with additional questions.',
    subtitleCandidate: 'A recruiter will follow up with additional questions.',
  },
};

export default function ResultScreen({ result, role = 'recruiter', answers = [], questions = [], onReset }) {
  const v = VARIANTS[result] || VARIANTS.review;
  const title = role === 'candidate' ? v.titleCandidate : v.titleRecruiter;
  const subtitle = role === 'candidate' ? v.subtitleCandidate : v.subtitleRecruiter;
  const Icon = v.Icon;

  const reviewAnswers = result === 'review'
    ? answers.filter((a) => a.answer === 'unsure')
    : [];

  return (
    <div
      className="staffing-result"
      data-testid="staffing-result"
      data-result={result}
      style={{ '--result-color': v.color }}
    >
      <div className="staffing-result-glow" aria-hidden="true" />
      <div className="staffing-result-icon">
        <Icon size={92} strokeWidth={1.6} />
      </div>
      <h1 className="staffing-result-title" data-testid="staffing-result-title">{title}</h1>
      <p className="staffing-result-subtitle">{subtitle}</p>

      {role === 'recruiter' && (
        <div className="staffing-result-summary" data-testid="staffing-result-summary">
          {answers.map((a) => {
            const q = questions.find((q) => q.id === a.question_id);
            return (
              <div key={a.sequence_num} className={`sr-row sr-row--${a.answer}`}>
                <span className="sr-q">{q?.text_en || a.question_id}</span>
                <span className="sr-a">{a.answer.toUpperCase()}</span>
              </div>
            );
          })}
        </div>
      )}

      {role === 'candidate' && reviewAnswers.length > 0 && (
        <ul className="staffing-result-review-list">
          {reviewAnswers.map((a) => {
            const q = questions.find((q) => q.id === a.question_id);
            return <li key={a.sequence_num}>· {q?.text_en || a.question_id}</li>;
          })}
        </ul>
      )}

      {role === 'recruiter' && onReset && (
        <button className="staffing-btn staffing-btn--primary mt-6" onClick={onReset} data-testid="result-reset-btn">
          <RotateCcw className="w-4 h-4" />
          <span>Start New Interview</span>
        </button>
      )}
    </div>
  );
}
